import React from "react"
import * as styles from "./gamesPrepare.module.scss"
import config from "@config"
import alertImg from "@images/2x/33aa.png"
import btnUploadImg from "@images/update/upload.png"
import btn2021GamesImg from "@images/2x/17aa.png"
import Clickable from "@src/components/clickable"
import classnames from "@src/utils/classnames"
import Section from "@src/components/section"

const GamesPrepare = () => {
  return (
    <>
      <div className={styles.alert}>
        <div>
          <img className={styles.alertLogo} src={alertImg} alt="alert" />
        </div>
        <p>游戏提交时间延长至5月4日24点</p>
        <div>
          <Clickable
            appNavTo={config.links.upload}
            className={classnames("img-btn", styles.btn)}
          >
            <img src={btnUploadImg} alt="upload" />
          </Clickable>
          <Clickable
            appNavTo={config.links.event2021Games}
            className={classnames("img-btn", styles.btn)}
          >
            <img src={btn2021GamesImg} alt="2021" />
          </Clickable>
        </div>
      </div>
      <div className={styles.sections}>
        <Section
          title={
            <>
              提交游戏时，
              <br />
              需要你准备好以下素材
            </>
          }
        >
          <ol>
            <li>
              团队名称（请填写在微信群公告中填写的名字，方便工作人员后续和你联系哦）
            </li>
            <li>
              添加组员信息（请提前收集组员的机核账号，可将所有组员机核网账号关联到游戏）
            </li>
            <li>游戏名称（可包含中英文）</li>
            <li>
              游戏类型，可包含游戏题材、类型、体验人数（比如：科幻 / 冒险 / 单人
              ）
            </li>
            <li>游戏文件（可以是百度网盘、itch链接、附件等）</li>
            <li>游戏项目安装说明、及足够让游戏项目运行的相关文件</li>
            <li>游戏简短介绍（200-300 字左右）</li>
            <li>游戏图片： 建议是游戏主视觉； 尺寸：880x508 横图</li>
            <li>
              游戏内图片/gif：需要是横版，静态图需要png格式；也建议大家提交游戏内gif图，单个gif请小于8M。
            </li>
            <li>
              游戏介绍视频（非必须项）：2～5min左右（5月18日开启线上游戏试玩活动的时候，此视频将会和“游戏介绍”一起，更新在你的游戏页中，作为玩家了解你游戏的第一步，所以请以此为前提，来制作你的介绍视频吧～）；大小请小于5G。
            </li>
          </ol>
        </Section>
        <Section
          title={
            <>
              提交游戏时，
              <br />
              需要注意的问题
            </>
          }
        >
          <p>
            在提交作品时，需要你提供足够的文件和安装说明，使其能够在 Windows
            或MAC
            上运行起来（当然你也可以提供多版本游戏安装包，比如额外提供「移动端」等），
            如果在默认系统配置之外要额外配置和安装的，也请开发者提供说明。
          </p>

          <p>
            在后期安装测试时，或在必要时非常需要开发者协助我们进行安装，如果有些游戏可能存在电脑配置要求，为保证线下展示效果，请开发者在提交作品前进行测试和优化。
          </p>
        </Section>
        <Section
          title={
            <>
              在规定时间
              <br />
              来不及提交游戏作品怎么办？
            </>
          }
        >
          <p>
            如果未能在规定时间内提交游戏作品（5月4日24:00之前），但依然想参与5月18日「线上试玩」活动，可以继续提交你的游戏作品，游戏作品依然会在「线上试玩」活动中展出，但将默认为放弃线上评选资格；
          </p>
        </Section>
        <Section
          title={
            <>
              提交了作品，
              <br />
              后续想优化怎么办？
            </>
          }
        >
          <p>
            5月18日「线上游戏试玩」活动中的游戏包以5月4日24:00前提交的为准，提交后将不接受更新；但你可以继续优化作品，可以在核聚变现场展出新的版本。
          </p>
        </Section>
        <Section
          title={
            <>
              哪些行为
              <br />
              会被拒绝接收
            </>
          }
        >
          <ol>
            <li>
              提交18+、过度色情、暴力、反社会等内容，可参考
              <a href="https://www.esrb.org/">ESRB评级</a>
            </li>
            <li>任何的抄袭、使用无版权内容；</li>
            <li>5月4日24点之前未能提交作品；</li>
            <li>提交并不能运行的游戏文件。</li>
          </ol>
        </Section>
      </div>
      <div className={styles.copyright}>
        本次活动最终解释权将归机核官方所有，官方将有权对包括但不限于违反上述规则的团队项目进行拒绝接收处理。
      </div>
    </>
  )
}

export default GamesPrepare
